import { Component } from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { Option } from 'interfaces/component'
import { State } from 'interfaces/state'
import { LocationOption } from 'interfaces/locations'
import { InputTheme } from 'interfaces/component'
import AutosuggestWrapped, { AutosuggestWrappedOwnProps } from 'components/atoms/inputs/AutosuggestWrapped'
import { searchCitiesActionCreator, registerCitiesAutosuggestActionCreator, destroyCitiesAutosuggestActionCreator } from 'actions/locationsActions'
import Registerable, { RegisterableDispatchProps, RegisterableOwnProps } from 'components/utils/Registerable'

type CityStateFieldInnerOwnProps = {
  name: string
  theme?: InputTheme
  onChange?: (option: Option<number>) => void
  disabled?: boolean
  id: string
}

type CityStateFieldInnerStateProps = {
  isLoading: boolean
  options: LocationOption[]
  lastSentQuery: string
}

type CityStateFieldInnerDispatchProps = {
  searchCities: (id: string, text: string) => void
}

type CityStateFieldInnerProps = CityStateFieldInnerStateProps & CityStateFieldInnerDispatchProps & CityStateFieldInnerOwnProps

class CityStateFieldInner extends Component<CityStateFieldInnerProps> {

  render () {
    const {
      name, theme,
      disabled,
      isLoading, lastSentQuery, options,
      onChange,
    } = this.props

    const autosuggestProps: AutosuggestWrappedOwnProps<number> = {
      autoComplete: 'off',
      label: 'City, State',
      theme,
      isLoading,
      disabled,
      lastSentQuery,
      options,
      onRequestSuggestions: this.searchCities,
      qaMarker: 'city-state-input',
      shouldPlaceSelectedToInput: true,
    }

    return (
      <Field
        name={ name }
        onChange={ onChange }
        component={ AutosuggestWrapped }
        props={ autosuggestProps }
      />
    )
  }

  private searchCities = (query: string) => {
    const { searchCities, id } = this.props
    searchCities(id, query)
  }
}

const innerMapStateToProps = (state: State, { id }: CityStateFieldInnerOwnProps): CityStateFieldInnerStateProps => {
  const autosuggestState = state.app.locations.cities[id]

  return {
    isLoading: autosuggestState.loading,
    options: autosuggestState.options,
    lastSentQuery: autosuggestState.lastSentQuery,
  }
}

const innerMapDispatchToProps: CityStateFieldInnerDispatchProps = {
  searchCities: searchCitiesActionCreator,
}

const CityStateFieldInnerContainer = connect<
  CityStateFieldInnerStateProps,
  CityStateFieldInnerDispatchProps,
  CityStateFieldInnerOwnProps
>(innerMapStateToProps, innerMapDispatchToProps)(CityStateFieldInner)

// Registerable
const mapDispatchToProps: RegisterableDispatchProps = {
  register: registerCitiesAutosuggestActionCreator,
  destroy: destroyCitiesAutosuggestActionCreator,
}

const CityStateField = connect<
  {},
  RegisterableDispatchProps,
  RegisterableOwnProps<CityStateFieldInnerOwnProps>
>(undefined, mapDispatchToProps)(Registerable(CityStateFieldInnerContainer))

export default CityStateField
